import { CommonModule } from '@angular/common';
import { Component, Inject, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { PromptCreateService } from '../services/prompt-create.service';
import { DashboardService } from '../services/shared/dashboard.service';
import { SaveSuccessComponent } from '../save-success/save-success.component';
import { SubmitSuccessComponent } from '../components/common/submit-success/submit-success.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent } from '../components/common/components/button/button.component';
import { SelectDropdownComponent } from '../components/common/components/select-dropdown/select-dropdown.component';
import { SnackBarComponent } from '../components/common/components/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map } from 'rxjs';
import { ErrorNotficationComponent } from '../error-notfication/error-notfication.component';


@Component({
  selector: 'app-on-submit',
  standalone: true,
  imports: [MatDialogModule, CommonModule, FormsModule, MatIconModule, MatSelectModule, ReactiveFormsModule, ButtonComponent, SelectDropdownComponent],
  templateUrl: './on-submit.component.html',
  styleUrl: './on-submit.component.scss'
})
export class OnSubmitComponent {
  title = new FormControl();
  description = new FormControl();
  version_reason=new FormControl();
  notes = new FormControl();
  actionType: string = "add"
  cancelButtonText = "Cancel"
  selectedrating: number = -1;
  isSubmitDisabled: boolean = false;
  isCommentRequired: boolean = false;
  comments: string = '';
  selectedValue: number = 0;
  lastSelectedTabIndex:number=0;
  allcategory: any;
  promptUserService: any;
  promptUserDetails: any;
  fileNames: any[] = [];
  promptCreatedBy: unknown;
  promptCategory: unknown;
  categories: any = [];
  subcategories: any = [];
  promptDetails: any;
  userid: any;
  modal: any;
  createdbyarray: any;
  category_id: any = [];
  sub_category_id: any = null;
  onMyFavouriteClick: boolean = false;
  onMyPromptsClick: boolean = false;
  user_role: any = "";
  status: any = [];
  prompt_id: any;
  selectedCategory: any
  promptDetailsObj: any = [];
  successfullySavedData: any;
  fromGroup: boolean = false;
  promptFromCreateForm: string = '';
  categoryRequired: boolean = false;
  versionStatus: boolean = false;
  // category functionality
  category: any = null;
  subCategory: any = null;
  isSaveClicked: boolean = false;
  promptId: any = null;
  promptDetailsId: any = null;
  attch: any;
  permentattch: any;
  newAttachments: string[] = [];
  attachmentData: any;
  permentattchData: any;
  version:number=0;
  submitPromptHeaderTitle: string = "Submit Prompt"
  submitPromptTitle: string = "Please complete the following mandatory fields to submit your prompt."
  forType:string='';
  variant:number=0;
  variant_reason=new FormControl('');
  latest_version:number=0;
  subTitle='';
  time: string = "00.00"
  time_val = signal<boolean>(false);
  timeFloat: number = 0.0

  constructor(
    private snackBar: MatSnackBar, 
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<OnSubmitComponent>, private promptCreateService: PromptCreateService, private fb: FormBuilder, private dialog: MatDialog, private dashboardService: DashboardService, private router: Router) {
      this.user_role = this.dashboardService.user_role
      this.userid = this.dashboardService.user_id;
    this.promptCreateService.promptSaveResp$.subscribe(resp => {
      if (resp) {
      
        if(resp?.prompt?.id == data?.promptId){
        this.successfullySavedData = resp
        }
      }
    });
  
    
    if (data) {
   
      let cate_id = this.successfullySavedData?.prompt?.category_id ?? null;
      let sub_cate = this.successfullySavedData?.prompt?.sub_category_id ?? null
      this.attch = data.attachments,
      this.permentattch = data.perminentAttachments
      this.attachmentData = data.attachments;
      this.permentattchData = data.perminentAttachments
      this.lastSelectedTabIndex=data?.selectedTabIndex;
      this.versionStatus=data?.versionStatus;
      this.version=this.data?.version;
      this.variant=this.data?.variant;
      this.forType=this.data?.forType;
      this.latest_version=this.data?.latest_version;
      this.variant_reason.setValue(this.data?.variant_reason);

      if(data?.estimated_time) {
        let float_time = parseFloat(data?.estimated_time).toFixed(2);
        this.time = float_time;

        let isValidTime = Number(this.time);
        this.time_val.set(isValidTime > 0 ? true : false);
        this.timeFloat = parseFloat(this.time)
      }

      if((this.versionStatus && this.forType == 'version') || (!this.versionStatus && this.version>0)){
        this.title.disable();
       }else if((this.versionStatus && this.forType == 'variant') || (!this.versionStatus && this.variant>0 && this.version == 0) ){
      
      }
      if( this.successfullySavedData?.prompt?.title && this.successfullySavedData?.prompt_details?.length>1) {
        this.title.setValue(this.successfullySavedData?.prompt?.title)
      }
      else{
        if(data.title && data.title != "Create Prompt" ){
          this.title.setValue(data.title);
        } 
        else if(this.data.promptData?.length > 1) {
          this.title.setValue("");
        } else {
          this.title.setValue(this.data.promptData[0].prompt_name);
        }
      }
      
      this.promptDetails = this.successfullySavedData?.prompt_details;
      this.description.setValue(data?.description || this.successfullySavedData?.prompt?.description)
      this.notes.setValue(data?.notes || this.successfullySavedData?.prompt?.notes)
      if(this.versionStatus ){
        this.version_reason.setValue(''); //published only ask for reason just before draft. 
        this.variant_reason.setValue(''); //published only ask for reason just before draft. 
      
      }else{
        this.version_reason.setValue(data?.version_reason || this.successfullySavedData?.prompt?.version_reason);
        this.variant_reason.setValue(data?.variant_reason || this.successfullySavedData?.prompt?.variant_reason);
        
      }
      
      // this.category_id =  this.successfullySavedData?.prompt?.category_id;
      this.categories = data?.categories
      if( this.successfullySavedData?.prompt?.sub_category_id !=null || (data?.subcategories?.length>0 && data?.sub_category_id )){
        this.subcategories = data?.subcategories
      }
    
      this.promptFromCreateForm = data?.promptDetails;

     
      
      if((this.versionStatus || this.version>0) && data?.prompt_id != null ){
        this.promptId = data?.prompt_id;
      }
      else if(data?.promptId != null) {
        this.promptId = data?.promptId;
      }
      else {
        this.promptId = this.successfullySavedData?.prompt?.id
      }
  
      if (cate_id != null && this.categories) {
        let obj = { name: '', id: 0 }
        this.categories.filter((x: any) => {
          if (x.id == cate_id) {
            obj.name = x.name
            obj.id = x.id
          }
        })
        this.category = obj
      }
      else {
        this.category = data?.category_id;
      }


      if (sub_cate != null && this.categories) {
        let obj = { name: '', id: 0 }
        this.categories.filter((x: any) => {
          if (x.id == cate_id) {
            if (x.value.subcategories.length > 0) {
              x.value.subcategories.filter((a: any) => {
                if (a.id == sub_cate) {
                  obj.name = a.name
                  obj.id = a.id
                }
              })
           this.subcategories =  x.value.subcategories
            }
          }
        })
        this.subCategory = obj
      }
      else {
     
        if(this.subcategories?.length>0){
        this.subCategory = data?.sub_category_id;
        }
      }
      // this.title.setValue(data?.prompt_name);
      // this.title.setValue(data?.title || this.successfullySavedData?.prompt?.title);
      // this.promptDetails =this.successfullySavedData?.prompt_details[0];
      // this.category_id =  this.successfullySavedData?.prompt?.category_id;
      // this.categories = data.categories
      // this.subcategories = data.subcategories
      // this.selectedCategory = this.categories.find((c: any) => c.id == Number(this.category_id))
      // this.subcategories = this.selectedCategory?.value?.subcategories ? this.selectedCategory.value.subcategories : [];
      // this.category.setValue(this.selectedCategory?.value);
      this.promptFromCreateForm = data?.promptDetails;





     
        
          // if(this.promptDetails) {
          //   this.promptDetails.map((id:any) => {
          //     let obj = {
          //       "prompt_name": id.prompt_name,
          //       "prompt": id?.prompt || "",
          //       "prompt_detail_id": id.id ?? null,
          //       "order_number": id?.order_number,
          //       "model_id": id.model_id,
          //       "permanent_attachments": id?.permanent_attachments.map((attachment: any) => attachment) ?? [],
          //       "attachments": id?.attachments?.map((attachment: any) => attachment) ?? [],
          //       "variables": id?.prompt_variables ?? []
          //     }
          //     this.promptDetailsObj.push(obj)
          //   })
          // } else {
          for (let i = 0; i < this.data.promptData?.length; i++) {
            if(this.promptDetails) {
              let a  = [...this.promptDetails?.filter((x:any)=>{
                if(x.order_number == this.data.promptData[i].order_number) {
                  return x.id;
                }
              })]
              let obj = {
                "prompt_name": this.data.promptData[i].prompt_name,
                "prompt": this.data.promptData[i]?.prompt || "",
                "prompt_detail_id": (a && a.length > 0) ? a[0].id : null,
                "order_number": this.data.promptData[i]?.order_number,
                "model_id": this.data.promptData[i].model_id,
                "permanent_attachments": this.data.promptData[i]?.permanent_attachments.map((attachment: any) => attachment) ?? [],
                "attachments": this.data.promptData[i]?.attachments?.map((attachment: any) => attachment) ?? [],
                "variables": this.data.promptData[i]?.prompt_variables ?? [],
                "notes":this.data.promptData[i]?.notes
              }
              this.promptDetailsObj.push(obj)
            } else {
              let obj = {
                "prompt_name": this.data.promptData[i].prompt_name,
                "prompt": this.data.promptData[i]?.prompt || "",
                "prompt_detail_id":  this.data.promptData[i]?.prompt_detail_id ?? null ,
                "order_number": this.data.promptData[i]?.order_number,
                "model_id": this.data.promptData[i].model_id,
                "permanent_attachments": this.data.promptData[i]?.permanent_attachments.map((attachment: any) => attachment) ?? [],
                "attachments": this.data.promptData[i]?.attachments?.map((attachment: any) => attachment) ?? [],
                "variables": this.data.promptData[i]?.prompt_variables ?? [],
                "notes":this.data.promptData[i]?.notes
              }
              this.promptDetailsObj.push(obj)
            }
 
          
        }
        
        
        if(data.promptData.length == 1) {
          this.submitPromptHeaderTitle = "Submit Prompt";
          this.submitPromptTitle = "Please complete the following mandatory fields to submit your prompt."
        } else if(data.promptData.length > 1) {
          this.submitPromptHeaderTitle = "Submit Chain of Prompt";
          this.submitPromptTitle = "Please complete the following mandatory fields manually to submit your prompt chain."
        }

      this.dialogRef.updateSize('300vw', '300vw')
    }
  }

  async ngOnInit() {
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
  }



  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onClose() {
    this.dialogRef.close(true);
  }

  selectCategory(event: any) {
    // this.categoryRequired = false;
    // this.category_id = +(event.target as HTMLSelectElement).value
    // const selectedcat = this.category_id;
    // let a = this.categories.filter((cat: any) => {
    //   if (cat.id == this.category_id) {
    //     return cat
    //   }
    // });
    // this.subcategories = a && a.length > 0 ? a[0].value.subcategories : [];
    // this.sub_category_id = this.subcategories[0]?.id;
    this.category = event;
    this.subCategory = null;
    this.subcategories = this.categories.find((category: any) => category.name === event.name)?.value?.subcategories?.map((subCategory: any) => ({ name: subCategory.name, value: subCategory.id })) ?? [];
  }


  selectSubCategory(event: any) {
    this.subCategory = event;
  }


  onChange(event: any) {
    if (event !== null || event !== undefined || event !== '') {
      this.fromGroup = false;
    }
  }

  // onTitleChange(event: any){
  //   if (event !== null || event !== undefined || event !== '' ) {
  //     this.titleRequired = false;
  //   }
  // }
  // onCategoryChange(event: any){
  //   if (event !== null || event !== undefined || event !== '' ) {
  //     this.categoryRequired = false;
  //   }
  // }

  private parseTime(): { hours: number, minutes: number } {
    const [h, m] = this.time.split(".").map(Number);
    return {
      hours: isNaN(h) ? 0 : Math.min(Math.max(h, 0), 99), 
      minutes: isNaN(m) ? 0 : Math.min(Math.max(m, 0), 59)
    }
  }

  private formatTime(h: number, m: number): string {
    const hh = String(h).padStart(2, '0');
    const mm = String(m).padStart(2, '0');
    return `${hh}.${mm}`
  }

  increaseHour() {
    const {hours,  minutes} = this.parseTime();
    const newHours = Math.min(hours + 1, 99);
    this.time = this.formatTime(newHours, minutes)

    let isValidTime = Number(this.time);
    this.time_val.set(isValidTime > 0 ? true : false);
    this.timeFloat = parseFloat(this.time)
  }

  decreaseHour() {
    const {hours, minutes} = this.parseTime();
    const newHours = Math.max(hours - 1, 0);
    this.time = this.formatTime(newHours, minutes);
    
    let isValidTime = Number(this.time);
    this.time_val.set(isValidTime > 0 ? true : false);
    this.timeFloat = parseFloat(this.time)
  }

  validateAndFormatTime() {
    const timePattren = /^(\d{1,2}).([0-5]\d)$/;
    let validTime = parseFloat(this.time).toFixed(2);
    const match = validTime.match(timePattren);

    if(match) {
      let hours = parseInt(match[1], 10);
      let minutes = parseInt(match[2], 10);

      if (hours > 99) hours = 99;
      if (minutes > 59) minutes = 59;

      this.time = this.formatTime(hours, minutes);
      this.timeFloat = parseFloat(this.time);

      let isValidTime = Number(this.time);
      this.time_val.set(isValidTime > 0 ? true : false);
    } else {
      this.time = '00.00'; // fallback if invalid
      let isValidTime = Number(this.time);
      this.time_val.set(isValidTime > 0 ? true : false);
    }
  }

  onSubmit(event: any) {
    this.isSaveClicked = false
    // let obj = {
    //   "prompt_name": this.title.value,

    //   "prompt": this.promptDetails?.prompt || this.promptFromCreateForm || "",
    //   "prompt_detail_id": this.promptDetailsId,
    //   "order_number": 1,
    //   "model_id": 2,
    //   "permanent_attachments": this.promptDetails?.permanent_attachments.map((attachment: any) => attachment) ?? [],
    //   "attachments": this.promptDetails?.attachments?.map((attachment: any) => attachment) ?? [],
    //   "variables": [
    //     "c7",
    //     ["c7_1", "c7_2"]
    //   ]
    // }

    let request={};

    // if (this.forType == 'variant'|| (this.variant>0 && this.version ==0)  ){ //
    if((this.versionStatus && this.forType == 'variant') || (!this.versionStatus && this.variant>0 && this.version == 0)){
      request={
      "title": this.title.value,
      "description": this.description.value ?? '',
      "notes": this.notes.value ?? '',
      "category_id": (this.category?.id || this.category?.value) ?? null ,
      "sub_category_id": (this.subCategory?.id || this.subCategory?.value) ?? null,
      "prompt_id": this.versionStatus? null: this.data?.prompt_id ?? null,
      "user_id": +this.userid,
      "action_type": 'submit',
      "prompt_type": this.promptDetailsObj.length == 1 ? "normal" : 'chain',
      "lastselectedTabIndex":this.lastSelectedTabIndex,
      "prompt_details": this.promptDetailsObj,
      "variant":this.versionStatus?this.data?.variant+1:this.data?.variant,
      "variant_reason":this.variant_reason.value?? '',
      "variant_source": this.data?.source_prompt_id,
      "estimated_time": this.timeFloat,
      //"version_reason":this.version_reason.value ?? '',
      //"source_prompt_id" : this.data?.source_prompt_id,
      "version":0, //this.versionStatus?this.data?.latest_version+1:this.data?.version,
      //"version_reason":this.version_reason.value?? '',
      //"source_prompt_id" : this.data?.source_prompt_id,
      //"source_version": this.data?.source_version,


      // "title":  this.title.value,
      //  "description":this.description.value ?? '',
      //  "notes": this.notes.value ?? '',
      //  "category_id": this.category?.value?.id || this.category?.value,
      //  "sub_category_id": this.subCategory?.value?.id ?? null,
      //  "user_id": +this.userid,
      //  "action_type": 'submit',
      //  "prompt_type": this.promptDetailsObj.length == 1 ? "normal" : 'chain',
      //  "prompt_id" : this.versionStatus?null:this.promptId ?? null,//this.promptId ?? null, 
      //  "prompt_details":this.promptDetailsObj,
      //   //this.versionStatus?this.promptDetailsObj?.prompt_details?.forEach((data:any)=> {data.prompt_detail_id=null;}):this.promptDetailsObj,
      //  "lastselectedTabIndex":this.lastSelectedTabIndex,
      //  "variant":this.data?.variant+1,
      //  "variant_reason":this.variant_reason.value?? '',
      //  "variant_source": this.data?.promptId,

    }

  }else{
    request={
    "title": this.title.value,
    "description": this.description.value ?? '',
    "notes": this.notes.value ?? '',
    "category_id": (this.category?.id || this.category?.value) ?? null ,
    "sub_category_id": (this.subCategory?.id || this.subCategory?.value) ?? null,
    "prompt_id": this.versionStatus?null:this.promptId ?? null,
    "user_id": +this.userid,
    "action_type": 'submit',
    "prompt_type": this.promptDetailsObj.length == 1 ? "normal" : 'chain',
    "lastselectedTabIndex":this.lastSelectedTabIndex,
    "prompt_details": this.promptDetailsObj,
    "version_reason":this.version_reason.value ?? '',
    "version":this.versionStatus?this.data?.latest_version+1:this.data?.version,
    "source_prompt_id" : this.data?.source_prompt_id,
    "source_version": this.data?.source_version,
    "variant":this.data?.variant,
    "variant_reason":this.data?.variant_reason?? '',
    "variant_source": this.data?.variant_source_id,
    "estimated_time": this.timeFloat
    }
  }

  if ((this.versionStatus && this.forType == 'variant') || (!this.versionStatus && this.variant>0 && this.version == 0)){
    if(!this.variant_reason.value){
      this.isSaveClicked = true
      return;
    }
  }else if((this.versionStatus && this.forType == 'version') || (!this.versionStatus && this.version>0)){
    if(!this.version_reason.value  ){
      this.isSaveClicked = true
      return;
    }
  }


  
    if(((this.versionStatus && this.forType == 'version') || (!this.versionStatus && this.version>0))){
      let version=this.versionStatus?(this.data?.latest_version+1):this.data?.version;
      this.subTitle+=' version '+version;
    }else if(this.forType == 'variant' || this.variant>0){
      this.subTitle+=' variant '+(this.data?.variant+1);
    }
    //return;
    if (!this.title.value || !this.description.value || !this.category || (this.subcategories?.length > 0 && this.subCategory == null) || !this.time_val() ) {
      this.isSaveClicked = true
      return;
    }

 
   if(this.promptDetailsObj){

    let breakindi=false;
    this.promptDetailsObj.map((prompt :any)=>{
      if(prompt.prompt == '' || prompt.prompt_name == '' && breakindi == false ){
        this.openSnackbar("!Can't Submit. please provide the required details for the prompt", 'Submission error', 'error-snackbar')
        breakindi = true;
      }
    })

    if(!breakindi){
        this.title.value ? (
          this.promptCreateService.OnSubmit(request).subscribe(res => {
            if (res.status_code === 200) {
              this.promptCreateService.promptSaveResp$.next(null);
              const preSignedUrlRequest = {
                prompt_id: res?.data?.prompt?.id,
                title: res?.data?.prompt?.title,
                url_type: 'put_object',
                prompt_details: res?.data?.prompt_details?.map((detail: any) =>
                ({
                  prompt_detail_id: detail?.id,
                  permanent_attachments: detail?.permanent_attachments,
                  attachments: detail?.attachments,
                }))
              };
              // this.promptCreateService.getPreSignedUrl(preSignedUrlRequest).subscribe(res => {
              //   if(res.status_code === 200) {
              //     const { prompt_details } = res?.data;
              //     prompt_details?.forEach((detail: any) => {
              //       detail?.permanent_attachments?.forEach((attachment: any) => {
              //         const file = this.promptDetails.perminentAttachments?.find((file: any) => file?.name === attachment?.file_name)
              //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
              //     
              //         })
              //       })
              //       detail?.attachments?.forEach((attachment: any) => {
              //         const file = this.promptDetails.attachments?.find((file: any) => file?.name === attachment?.file_name)
              //         this.promptCreateService.uploadFileToS3(attachment.url, file).subscribe(res => {
              //        
              //         })
              //       })
              //     })
              //   }
              // })
    
              // -------------------- code for upload to s3 using presigned url -----
              if (res?.data?.prompt_details) {
                res?.data?.prompt_details?.forEach((each_prompt_detail: { permanent_attachments: any[]; id: any; attachments: any[]; }) => {
                  let newTempPerAttach: any = [];
                this.permentattchData?.forEach((item: any) => {
                  if (item.file_type) {
                    newTempPerAttach.push(item.selected.name);
                  }
                });
                if(newTempPerAttach.length > 0) {
                  each_prompt_detail?.permanent_attachments.forEach(each_permanent_attachments => {
                    if (newTempPerAttach.includes(each_permanent_attachments)) {
                      const presSignedUrlRequest = {
                        prompt_id: res?.data?.prompt?.id,
                        title: res?.data?.prompt?.title,
                        url_type: 'put_object',
                        prompt_detail_id: each_prompt_detail?.id,
                        attachment_type: "permanent_attachments",
                        file_name: each_permanent_attachments,
                        user_id:this.userid
                      }
                      this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
                          if (response?.data) {
                            const presignedUrl = response?.data?.url;
                            const file = this.permentattch?.find((file: any) => file.selected.name === each_permanent_attachments)
                          
                            this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
                                  next: (res) => {
                                   
                                    // alert("File uploaded successfully");
                                  },
                                  error: (error) => {
                                    console.error("Error uploading file:", error);
                                    // alert("File upload failed");
                                  }
                                });
            
                          } else {
                           
                          }
                      })
                    }
                  })
                }

                let newTempAttach: any = [];
                this.attachmentData?.forEach((item: any) => {
                  if (item.file_type) {
                    newTempAttach.push(item?.selected?.name); 
                  }
                });
                if(newTempAttach.length > 0) {
                  each_prompt_detail?.attachments.forEach(each_attachments => {
                    if (newTempAttach.includes(each_attachments)) {
                      const presSignedUrlRequest = {
                        prompt_id: res?.data?.prompt?.id,
                        title: res?.data?.prompt?.title,
                        url_type: 'put_object',
                        prompt_detail_id: each_prompt_detail?.id,
                        attachment_type: "attachments",
                        file_name: each_attachments,
                        user_id:this.userid
                      }
                      this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
                        if (response?.data) {
                          const presignedUrl = response?.data?.url;
                          const file = this.attch?.find((file: any) => file.selected.name === each_attachments)
                          
         
                          this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
                            next: (res) => {
                              
                              newTempAttach = []; 
                            },
                            error: (error) => {
                              console.error("Error uploading file:", error);
                              // alert("File upload failed");
                            }
                          });
                        } else {
                         
                        }
                      })
                    }
                  })
                }
                })
              }
    
              // const dialogRef = this.dialog.open(SubmitSuccessComponent, {
              //   data: {
              //     message: this.title.value,
              //     title: "Submited successfully",
              //     action_type: 'submit'
              //   }
              // });
              let messageData;
              const variant = res?.data?.prompt?.variant;
              const version = res?.data?.prompt?.version;
              
              const promptTitle = this.title?.value;
              if (this.promptDetailsObj && this.promptDetailsObj.length > 1) {
                // messageData = `The prompt chain '${this.promptUserDetails?.title}' has been approved and published successfully`
                messageData = `The prompt chain `;
                if ((variant >= 1) && (version >= 1)) {
                  messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
                } else if ((variant >= 1) && (version < 1)) {
                  messageData += `'${promptTitle} - Variant ${variant}'`;
                } else if ((version >= 1 && (variant < 1))) {
                  messageData += `'${promptTitle} - Version ${version}'`;
                } else {
                  messageData += `'${promptTitle}'`;
                }
                messageData += ' has been submitted successfully';
              } else if(this.promptDetailsObj && this.promptDetailsObj.length == 1) {
                // messageData = `The prompt '${this.promptUserDetails?.title}' has been approved and published successfully`
                messageData = `The prompt `;
                if ((variant >= 1) && (version >= 1)) {
                  messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
                } else if ((variant >= 1) && (version < 1)) {
                  messageData += `'${promptTitle} - Variant ${variant}'`;
                } else if ((version >= 1 && (variant < 1))) {
                  messageData += `'${promptTitle} - Version ${version}'`;
                } else {
                  messageData += `'${promptTitle}'`;
                }
                messageData += ' has been submitted successfully';
              }

              // if (this?.promptDetailsObj?.length > 1) {
              //   messageData = `The prompt chain '${this.title.value}'` + ' has been submitted successfully'
              // } else {
              //   messageData = `The prompt '${this.title.value}'` + ' has been submitted successfully'
              // }
              
              const dialogRef = this.dialog.open(ErrorNotficationComponent, {
                data: {
                  message: messageData,
                  title: "Submitted successfully",
                  action_type: 'add',
                  cssClass: 'success-snackbar'
                }
              });
              this.router.navigateByUrl('/home/dashboard');
              this.dialogRef.close(res?.data)
            } else {
              this.promptDetailsObj = []
              this.promptCreateService.promptSaveResp$.next(null);
            }
          }, (error: HttpErrorResponse) => {
            if (error?.status === 409) {
              this.dialogRef?.close({});
              this.openSnackbar(error?.error?.message, 'Title Already in Use', 'error-snackbar');
            } 
            
          })
        ) : {};
      
    

   }

  }


  }
  openSnackbar(message: string, title: string, cssClass: string) {
        // this.snackBar.openFromComponent(SnackBarComponent, {
        //   data: { message: message, type: type },
        //   duration: 3000, // Duration in milliseconds,
        //   horizontalPosition: 'center',
        //   verticalPosition: 'top',
        //   panelClass: [cssClass],
        // });
         const dialogRef = this.dialog.open(ErrorNotficationComponent, {
                       data: {
                         message: message,
                         title: title,
                         action_type: 'add',
                         cssClass: cssClass
                       }
                     });
      }

}
